import type { TicketPriority } from '@beacon/core';
import { Dropdown } from '@/components/ui/dropdown.js';
import { Priority } from './priority.js';

const PRIORITIES: TicketPriority[] = ['p1', 'p2', 'p3'];

const DESCRIPTIONS: Record<TicketPriority, string> = {
  p1: 'Critical',
  p2: 'Standard',
  p3: 'Low',
};

export function PriorityDropdown({
  value,
  onChange,
}: {
  value: TicketPriority;
  onChange: (next: TicketPriority) => void;
}) {
  return (
    <Dropdown<TicketPriority>
      value={value}
      onChange={onChange}
      ariaLabel="Change priority"
      items={PRIORITIES.map((p) => ({
        value: p,
        label: <Priority p={p} />,
        description: DESCRIPTIONS[p],
      }))}
      renderTrigger={(item) => item && <Priority p={item.value} />}
    />
  );
}
